import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09f3679d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Adres", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Kenmerken", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Slaapkamers:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Oppervlak:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "2", -1))

import { ref } from 'vue'
import SecureLS from 'secure-ls'


export default /*#__PURE__*/_defineComponent({
  __name: 'BuildingDetailsWidget',
  setup(__props) {

const buildings = ref(new SecureLS({ isCompression: false }).get('buildings') || [])

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: `Uw ${buildings.value.length < 2 ? 'object' : 'objecten'}`,
    bordered: false
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buildings.value, (building) => {
        return (_openBlock(), _createBlock(_component_a_row, {
          class: _normalizeClass(buildings.value.length > 2 ? 'mb-0' : null),
          key: building.id
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              xs: { span: 24 },
              md: { span: 24 },
              xl: { span: 8 }
            }, {
              default: _withCtx(() => [
                _hoisted_1,
                _createElementVNode("p", null, [
                  _createTextVNode(_toDisplayString(building.address), 1),
                  _hoisted_2,
                  _createTextVNode(_toDisplayString(building.zipcode) + " " + _toDisplayString(building.city), 1)
                ])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_a_col, {
              xs: { span: 24 },
              md: { span: 24 },
              xl: { span: 14, offset: 2 },
              class: "building-details"
            }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, {
                      xs: { span: 8 },
                      md: { span: 10 },
                      lg: { span: 10 }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, {
                      xs: { span: 14, offset: 2 },
                      md: { span: 13, offset: 1 },
                      lg: { span: 13, offset: 1 }
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", null, _toDisplayString(building.bedrooms), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, {
                      xs: { span: 8 },
                      md: { span: 10 },
                      lg: { span: 10 }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, {
                      xs: { span: 14, offset: 2 },
                      md: { span: 13, offset: 1 },
                      lg: { span: 13, offset: 1 }
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", null, [
                          _createTextVNode(_toDisplayString(building.living_size) + " m", 1),
                          _hoisted_6
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["class"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})